;(function () {

"use strict";

/* For image upload view */
require('blueimp-canvas-to-blob');
var ImageUploadTemplate = require('./templates/image-upload.html');

var ImageUploadView = Backbone.View.extend({
  className: 'image-upload',
  initialize: function (opts) {
    opts = opts || {};

    this.$anchor = opts.$anchor;

    this.$input = this.$anchor;

    this.limit = this.$anchor.data('limit');
    this.images = this.$anchor.data('images') || [];

    this.name = this.$input.attr('name');
    this.parent = opts.parent;

    this.canvas = document.createElement('canvas');
    this.ctx = this.canvas.getContext("2d");

    this.initDom();

    window.iuv = this;
  },
  initDom: function () {
    /* Prepare Dom */    
    this.$el.insertAfter(this.$anchor);
    this.$content = $("<span>");
    this.$content.appendTo(this.$el);
    this.$anchor.appendTo(this.$el);
    this.delegateEvents();
    if (this.images.length <= 0) {
      this.render(true);
    } else {
      this.render();
    }
  },
  input: function (e) {
    this.$input.trigger('click');
  },
  val: function () {
    // if (this.images) {
      // console.log('here');
      // console.log(this.images);
      // console.log(this.$input);
      // console.log([this.$input.val()]);

      // console.log('FORCERESIZE:');
      // console.log(this.forceResize);

      /* If the image was huge, force a png resize*/
      if (this.forceResize) {
        return this.images;
      }

      /* Otherwise */
      return [this.file];
      // return this.images;
    // } else {
      // return this.$input[0].files[0];
    // }
  },
  resize: function ($img) {
    var img = $img[0];
    var canvas = this.canvas;
    var MAX_WIDTH = 2048;
    var MAX_HEIGHT = 2048;
    var width = img.naturalWidth;
    var height = img.naturalHeight;
    
    if (width > MAX_WIDTH && height > MAX_HEIGHT) {
      this.forceResize = true;
    }

    if (width > height) {
      if (width > MAX_WIDTH) {
        height *= MAX_WIDTH / width;
        width = MAX_WIDTH;
      }
    } else {
      if (height > MAX_HEIGHT) {
        width *= MAX_HEIGHT / height;
        height = MAX_HEIGHT;
      }
    }

    this.canvas.width = width;
    this.canvas.height = height;
    this.ctx.drawImage(img, 0, 0, width, height);

    var url = this.canvas.toDataURL();
    this.updateImage(url);

    var self = this;

    var filetype = this.filename.split('.').pop();

    if (filetype === 'jpg' || filetype === 'jpeg') {
      filetype = 'image/jpeg';
    } else if (filetype === 'gif') {
      filetype = 'image/gif';
    } else {
      filetype = 'image/png';
    }

    _.defer(function () {
      self.canvas.toBlob(function (blob) {
        blob.url = url;
        self.blob = blob;
        self.images.push(blob);
        self.render(false, self.images.length-1);
      }, filetype);
    });
  },
  updateImage: function (file, onload) {
    var img = this.$img[0];
    img.onload = onload;
    img.src = file;
  },
  change: function (e, file) {
    if (this.limit && (this.images.length >= this.limit)) {
      alert('You can only have '+this.limit+' pictures. Please delete one before adding a new one.');
      return; 
    }
    this.changed = true;

    var self = this;
    var target;

    if (e) {
      target = e.target || e.srcElement;
    }
    file = file || target.files[0];

    this.file = file;
    this.filename = file.name; /*only works for single image uploaders*/

    var $img = this.$img;

    var reader = new FileReader();

    reader.onload = function() {
      self.updateImage(this.result, function () {
        self.resize($img);
      });
    };
    reader.readAsDataURL(file);
  },
  render: function (blank, idx) {
    console.log('rendering');
    console.log(blank);
    var html = _.template(ImageUploadTemplate)({images: this.images, blank: blank, idx: idx, limit: this.limit});
    this.$content.html(html);
    this.$img = this.$el.find('span.upload > img');
    this.$thumbs = this.$el.find('ul.thumbs');
  },
  events: {
    'click span.upload > img': 'input',
    'change input': 'change',
    'dragleave': function (e) {
      $(e.currentTarget).removeClass('hover');
      return false;
    },
    'dragover': function (e) {
      return false;
    },
    'dragenter': function(e) { 
      $(e.currentTarget).addClass('hover');
      return false;
    },
    'drop': function(e) {
      e.preventDefault();
      var file = e.originalEvent.dataTransfer.files[0];
      this.change(undefined, file); 
      $(e.currentTarget).removeClass('hover');
      return false;
    },
    'click li.delete': function (e) {
      var idx = this.$el.find('ul li.active').index();

      /* wont work since thumbs are screwed */
      if (idx === -1) {
        idx = 0;        
      }

      if (idx > -1) {
        this.images.splice(idx, 1);
      }

      if (this.images.length <= 0) {
        this.render(true);
      } else {
        this.render();
      }
      
      return false;
    },
    'click button': function (e) {
      this.render(true);

      return false;
    },
    'click ul.thumbs > li': function (e) {
      var $this = $(e.currentTarget);
      this.render(false, $this.index());

      return false;
    },
  }
});

module.exports = ImageUploadView;

}());